import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type TransferBatchCompletedSelfHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type TransferBatchCompletedSelfHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type TransferBatchCompletedSelfHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type TransferBatchCompletedSelfHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type TransferBatchCompletedSelfHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type TransferBatchCompletedSelfHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type TransferBatchCompletedSelfHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type TransferBatchCompletedSelfHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type TransferBatchCompletedSelfHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type TransferBatchCompletedSelfHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type TransferBatchCompletedSelfHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type TransferBatchCompletedSelfHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type TransferBatchCompletedSelfHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type TransferBatchCompletedSelfHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type TransferBatchCompletedSelfHeaderFragment = TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestApproved_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestDenied_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupAccessRequestSubmitted_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupAssetAssignedToYou_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupAssetStatusChanged_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupCommentCreated_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupCommentCreatedShareAccess_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupFileUploaded_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupReplyCreated_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupReplyCreatedShareAccess_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupTranscriptCompletedSelf_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupTransferBatchCompleted_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupUserMentioned_Fragment | TransferBatchCompletedSelfHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type TransferBatchCompletedSelfHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const TransferBatchCompletedSelfHeaderContent = /*#__PURE__*/ gql`
    fragment TransferBatchCompletedSelfHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
  }
}
    ${UserName}
${Text}` as unknown as DocumentNode<TransferBatchCompletedSelfHeaderContentFragment, unknown>;
export const TransferBatchCompletedSelfHeader = /*#__PURE__*/ gql`
    fragment TransferBatchCompletedSelfHeader on NotificationGroup {
  ... on NotificationGroupTransferBatchCompletedSelf {
    content {
      layout {
        ...TransferBatchCompletedSelfHeaderContent
      }
    }
  }
}
    ${TransferBatchCompletedSelfHeaderContent}` as unknown as DocumentNode<TransferBatchCompletedSelfHeaderFragment, unknown>;

        

        
export const useTransferBatchCompletedSelfHeaderFragment = (
  input: string | Omit<UseFragmentOptions<TransferBatchCompletedSelfHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<TransferBatchCompletedSelfHeaderFragment>({
    fragment: TransferBatchCompletedSelfHeader,
    fragmentName: 'TransferBatchCompletedSelfHeader',
    ...options,
  });
};
  
        
        

        
export const useTransferBatchCompletedSelfHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<TransferBatchCompletedSelfHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<TransferBatchCompletedSelfHeaderContentFragment>({
    fragment: TransferBatchCompletedSelfHeaderContent,
    fragmentName: 'TransferBatchCompletedSelfHeaderContent',
    ...options,
  });
};
  
        